module.exports = __webpack_public_path__ + "img/cement_optimizer-diagram.30faf10b.png";